module.exports = __webpack_public_path__ + "img/2-1.ebedd25c.webp";